<template>
  <div class="barrage-wrap" ref="wrap">
    <div
      ref="picture"
      v-show="isPicture === 'Y'"
      class="picture"
      :style="{
        background: `url(${resourcesSrc}) center center /cover no-repeat`,
      }"
    ></div>
    <video
      ref="video"
      v-show="isPicture === 'N'"
      class="video video-js vjs-default-skin vjs-big-play-centered"
      webkit-playsinline="true"
      playsinline="true"
      x-webkit-airplay="allow"
      x5-video-player-type="h5"
      x5-video-player-fullscreen="true"
      x5-video-orientation="portraint"
    >
      <source :src="resourcesSrc" />
    </video>
    <i
      v-show="isIos && isFullScreen"
      class="el-icon-error close"
      @click="handleCloseFullScreen"
    ></i>
  </div>
</template>

<script>
import videojs from "video.js";
import { replaceAll } from "@/utils";
const barrageX = 3; // 弹幕加速因子
let MEDIA_IMAGE_LOOP_TIME = 2 * 60; // 图片资源轮播时长默认2分钟
export default {
  name: "Barrage",
  props: {
    layoutType: {
      type: String,
      default: "2",
    }, // 默认理科馆屏2236x516
    isPicture: {
      type: String,
      default: "Y",
    }, //判断显示图片还是视频，Y是背景图片，N是视频
    resourcesSrc: {
      type: String,
      default:
        "https://mlibrary.fudan.edu.cn/oss/safecampus2/public/20220817/2xd028fz1p_111.jpeg",
      // "http://uat.eduzrb.com/oss/safecampus2/public/20220705/50h1xzi3lq_video.mp4",
      // "http://clips.vorwaerts-gmbh.de/big_buck_bunny.mp4",
    }, //资源路径
    barrageIsShow: {
      type: String,
      default: "Y",
    }, //是否显示弹幕-true显示
    barrageLogoIsShow: {
      type: String,
      default: "Y",
    }, //是否显示弹幕Logo-true显示
    barrageOpacity: {
      type: [String, Number],
      default: 0.6,
    }, //弹幕透明度
    barrageLogoUrl: {
      type: String,
      default: require("@/assets/images/barrageLogo.png"),
    }, //弹幕LogoUrl
    barrageWordColor: {
      type: String,
      default: "rgb(255, 255, 255)",
    }, //弹幕文字颜色
    barrageBackColor: {
      type: String,
      default: "rgb(191, 82, 115)",
    }, //弹幕背景颜色
    barrageDirection: {
      type: String,
      default: "H",
    }, //弹幕方向-H代表水平，V代表垂直
    barrageSpeed: {
      type: [String, Number],
      default: 0.3,
    }, //弹幕速度-0至1
    barrageFontSize: {
      type: [String, Number],
      default: "14",
    }, //弹幕字体大小
    qrCodeIsShow: {
      type: String,
      default: "N",
    }, //是否显示二维码,Y是，N否
    imgCarouselTime: {
      type: [String, Number],
      default: "2",
    }, //图片资源轮播时长
    barrageList: {
      type: Array,
      default() {
        return [
          // {
          //   content: "我是弹幕",
          //   time: "00:00:01",
          // },
        ];
      },
    }, // 弹幕列表
  },
  data() {
    return {
      isIos: false,
      isFullScreen: false,
    };
  },
  watch: {
    barrageList() {
      if (this.barrageIsShow === "Y") {
        this.barrageReset();
      }
    },
  },
  created() {
    // 判断是否是ios
    this.isIos = /(iPhone|iPad|iPod|IOS)/i.test(navigator.userAgent);
    if (this.imgCarouselTime && this.imgCarouselTime > 0) {
      MEDIA_IMAGE_LOOP_TIME = parseInt(this.imgCarouselTime) * 60;
    }
  },
  mounted() {
    // 需要显示弹幕时，做弹幕的初始化
    this.init();
  },
  methods: {
    // 时间格式转成总秒数
    handleTimeStrToSecond(timeStr) {
      const [hour, minute, second] = timeStr.split(":");
      let totalSecond = 0;
      totalSecond += parseInt(hour) * 60 * 60;
      totalSecond += parseInt(minute) * 60;
      totalSecond += parseInt(second);
      return totalSecond;
    },
    // 秒转成时间格式
    handleSecondToTimeStr(sec) {
      // 转换为式分秒
      let h = parseInt((sec / 60 / 60) % 24);
      h = h < 10 ? "0" + h : h;
      let m = parseInt((sec / 60) % 60);
      m = m < 10 ? "0" + m : m;
      let s = parseInt(sec % 60);
      s = s < 10 ? "0" + s : s;
      // 作为返回值返回
      return `${h}:${m}:${s}`;
    },
    // 弹幕重置
    barrageReset() {
      const that = this;
      that.barrageRealList = that.barrageList.map((item) => {
        item.width = that.barrageWidthHeightGet(item.content).width;
        item.height = that.barrageWidthHeightGet(item.content).height;
        item.left = that.barrageInitPositionGet().left;
        item.top = that.barrageInitPositionGet().top;
        item.showTime = that.handleTimeStrToSecond(item.time);
        item.stopDrawing = false;
        if (that.isPicture === "Y") {
          if (that.picCurrentTime) {
            if (item.showTime <= that.picCurrentTime) {
              item.stopDrawing = true;
            }
          }
        } else {
          if (that.player) {
            if (item.showTime <= that.player.currentTime()) {
              item.stopDrawing = true;
            }
          }
        }
        return item;
      });
    },
    // 初始化
    init() {
      const that = this;
      that.$wrap = that.$refs.wrap;
      that.wrapWidth = that.$wrap.offsetWidth;
      that.wrapHeight = that.$wrap.offsetHeight;
      if (that.isPicture === "Y") {
        if (that.barrageIsShow === "Y") {
          that.barrageReset();
        }
        that.handlePictureBarrage();
      } else {
        that.player = videojs(
          that.$refs.video,
          {
            controls: true,
            autoplay: true,
            loop: true,
            userActions: {
              doubleClick: false,
            },
            controlBar: {
              fullscreenToggle: false,
            },
          },
          () => {
            const btn = that.player.controlBar.addChild("button", {
              clickHandler: that.triggerFullScreen,
            });
            btn.addClass("vjs-fullscreen-control");
            btn.addClass("vjs-control");
            btn.addClass("vjs-button");
            if (that.barrageIsShow === "Y") {
              that.barrageReset();
              // 视频播放
              that.player.on("play", that.handleVideoPlay);
              // 视频暂停
              that.player.on("pause", that.handleVideoPause);
              // 进度条变化
              that.player.on("seeked", that.handleVideoSeeked);
            }
          }
        );
        // 弹幕是否停止
        that.barragePause = true;
        that.isFullScreen = false;
      }
    },
    // 触发全屏事件
    triggerFullScreen() {
      const that = this;
      if (that.isFullScreen) {
        // 使用video.js提供的exitFullscreen api，避免原生exitFullscreen的兼容问题
        that.isFullScreen = false;
        if (that.isIos) {
          that.$wrap.style.position = "relative";
        } else {
          that.player.exitFullscreen();
        }
        window.setTimeout(() => {
          if (that.barrageIsShow === "Y") {
            that.hanldeSeekOrScreenChangeBarrageReset();
          }
        }, 600);
      } else {
        if (that.isIos) {
          that.$wrap.style.position = "fixed";
          that.$wrap.style.top = 0;
          that.$wrap.style.left = 0;
          that.isFullScreen = true;
          window.setTimeout(() => {
            if (that.barrageIsShow === "Y") {
              that.hanldeSeekOrScreenChangeBarrageReset();
            }
          }, 600);
        } else {
          try {
            if (that.$wrap.requestFullscreen) {
              that.$wrap.requestFullscreen();
            } else if (that.$wrap.webkitRequestFullScreen) {
              that.$wrap.webkitRequestFullScreen();
            } else if (that.$wrap.mozRequestFullScreen) {
              that.$wrap.mozRequestFullScreen();
            } else if (that.$wrap.msRequestFullscreen) {
              that.$wrap.msRequestFullscreen();
            } else {
              that.player.requestFullscreen();
            }
            that.isFullScreen = true;
            window.setTimeout(() => {
              if (that.barrageIsShow === "Y") {
                that.hanldeSeekOrScreenChangeBarrageReset();
              }
            }, 600);
          } catch (err) {
            that.isFullScreen = true;
            // 如果原生全屏api出错，则使用video.js自带的全屏api
            that.player.requestFullscreen();
            window.setTimeout(() => {
              if (that.barrageIsShow === "Y") {
                that.hanldeSeekOrScreenChangeBarrageReset();
              }
            }, 600);
          }
        }
      }
    },
    // ios下关闭全屏
    handleCloseFullScreen() {
      const that = this;
      that.isFullScreen = false;
      that.$wrap.style.position = "relative";
    },
    // 照片弹幕
    handlePictureBarrage() {
      const that = this;
      that.picCurrentTime = 0;
      if (that.picCurrentSetInterTime) {
        window.clearInterval(that.picCurrentSetInterTime);
        that.picCurrentSetInterTime = null;
      }
      that.picCurrentSetInterTime = window.setInterval(() => {
        that.picCurrentTime++;
        if (that.picCurrentTime > MEDIA_IMAGE_LOOP_TIME) {
          that.picCurrentTime = 0;
          if (that.barrageIsShow === "Y") {
            that.barrageReset();
          }
        }
      }, 1000);
      if (that.picSetInterTime) {
        window.clearInterval(that.picSetInterTime);
        that.picSetInterTime = null;
      }
      that.picSetInterTime = window.setInterval(() => {
        if (that.barrageIsShow === "Y") {
          that.picBarrageRender();
        }
      }, 1000 / 60);
    },
    // 照片弹幕渲染
    picBarrageRender() {
      const that = this;
      that.$wrap.querySelectorAll(".barrage").forEach((node) => {
        node.remove();
      });
      that.barrageRealList.forEach((item) => {
        if (!item.stopDrawing && item.showTime <= that.picCurrentTime) {
          const _div = document.createElement("div");
          _div.style.opacity = that.barrageOpacity;
          _div.style.backgroundColor = that.barrageBackColor;
          if (that.barrageLogoIsShow === "Y") {
            const _img = document.createElement("img");
            _img.setAttribute("src", that.barrageLogoUrl);
            _img.setAttribute("class", "logo");
            _img.style.width = item.height - 4 + "px";
            _img.style.height = item.height - 4 + "px";
            if (that.barrageDirection === "V") {
              _img.style.width = item.width - 4 + "px";
              _img.style.height = item.width - 4 + "px";
            }
            _div.appendChild(_img);
          }
          const _span = document.createElement("span");
          if (that.barrageDirection === "V") {
            item.content = replaceAll(item.content, "!", "");
            item.content = replaceAll(item.content, "！", "");
            item.content = item.content.toUpperCase();
          }
          _span.innerText = item.content;
          _span.style.fontSize = 14 + "px";
          _span.style.color = that.barrageWordColor;
          if (that.barrageDirection === "V") {
            _div.setAttribute("class", "barrage v");
            item.top -= barrageX;
            _span.style.width = 14 + "px";
          } else {
            _div.setAttribute("class", "barrage");
            item.left -= barrageX;
            if (that.isFullScreen) {
              _div.style.width = item.width + 36 + "px";
            } else {
              _div.style.width = item.width + 6 + "px";
            }
          }
          _div.style.left = item.left + "px";
          _div.style.top = item.top + "px";
          _div.appendChild(_span);
          that.$wrap.appendChild(_div);
          if (that.barrageDirection === "V") {
            if (item.top <= item.height * -1) {
              item.stopDrawing = true;
            }
          } else {
            if (item.left <= item.width * -1) {
              item.stopDrawing = true;
            }
          }
        }
      });
    },
    // 视频开始播放
    handleVideoPlay() {
      const that = this;
      that.barragePause = false;
      if (that.setInterTime) {
        window.clearInterval(that.setInterTime);
        that.setInterTime = null;
      }
      that.setInterTime = window.setInterval(() => {
        that.barrageRender();
      }, 1000 / 60);
    },
    // 视频暂停播放
    handleVideoPause() {
      this.barragePause = true;
    },
    // 进度条变化
    handleVideoSeeked() {
      this.hanldeSeekOrScreenChangeBarrageReset();
    },
    // 进度条变化或者全屏切换时，弹幕重置
    hanldeSeekOrScreenChangeBarrageReset() {
      const that = this;
      const currentTime = that.player.currentTime();
      that.$wrap.querySelectorAll(".barrage").forEach((node) => {
        node.remove();
      });
      that.barrageRealList.forEach((item) => {
        item.stopDrawing = false;
        if (item.showTime >= currentTime) {
          item.left = that.barrageInitPositionGet().left;
          item.top = that.barrageInitPositionGet().top;
        } else {
          const diffTime = currentTime - item.showTime;
          const distance = diffTime * 60 * barrageX;
          let totalMoveDis = that.$wrap.offsetWidth + item.width;
          if (that.barrageDirection === "V") {
            totalMoveDis = that.$wrap.offsetHeight + item.height;
          }
          if (distance <= totalMoveDis) {
            if (that.barrageDirection === "V") {
              item.top = that.$wrap.offsetHeight - distance;
            } else {
              item.left = that.$wrap.offsetWidth - distance;
            }
            const _div = document.createElement("div");
            _div.style.opacity = that.barrageOpacity;
            _div.style.backgroundColor = that.barrageBackColor;
            if (that.barrageLogoIsShow === "Y") {
              const _img = document.createElement("img");
              _img.setAttribute("src", that.barrageLogoUrl);
              _img.setAttribute("class", "logo");
              _img.style.width = item.height - 4 + "px";
              _img.style.height = item.height - 4 + "px";
              if (that.barrageDirection === "V") {
                _img.style.width = item.width - 4 + "px";
                _img.style.height = item.width - 4 + "px";
              }
              _div.appendChild(_img);
            }
            const _span = document.createElement("span");
            if (that.barrageDirection === "V") {
              item.content = replaceAll(item.content, "!", "");
              item.content = replaceAll(item.content, "！", "");
              item.content = item.content.toUpperCase();
            }
            _span.innerText = item.content;
            _span.style.fontSize = 14 + "px";
            _span.style.color = that.barrageWordColor;
            if (that.barrageDirection === "V") {
              _div.setAttribute("class", "barrage v");
              item.top -= barrageX;
              _span.style.width = 14 + "px";
            } else {
              _div.setAttribute("class", "barrage");
              item.left -= barrageX;
              if (that.isFullScreen) {
                _div.style.width = item.width + 36 + "px";
              } else {
                _div.style.width = item.width + 6 + "px";
              }
            }
            _div.style.left = item.left + "px";
            _div.style.top = item.top + "px";
            _div.appendChild(_span);
            that.$wrap.appendChild(_div);
          } else {
            item.stopDrawing = true;
          }
        }
      });
    },
    // 获取单个弹幕的宽度和高度
    barrageWidthHeightGet(text) {
      const that = this;
      const _div = document.createElement("div");
      _div.style.display = "flex";
      _div.style.alignItems = "center";
      _div.style.justifyContent = "center";
      _div.style.flexWrap = "nowrap";
      _div.style.position = "absolute";
      _div.style.top = 0;
      _div.style.left = 0;
      _div.style.zIndex = -1;
      _div.style.opacity = 0;
      _div.style.borderRadius = "200px";
      _div.style.padding = "4px 5px";
      const _span = document.createElement("span");
      _span.style.display = "block";
      if (that.barrageDirection === "V") {
        text = replaceAll(text, "!", "");
        text = replaceAll(text, "！", "");
        text = text.toUpperCase();
      }
      _span.innerText = text;
      _span.style.fontSize = 14 + "px";
      if (that.barrageDirection === "V") {
        _div.style.flexDirection = "column";
        _span.style.width = 14 + "px";
      }
      _div.appendChild(_span);
      document.body.appendChild(_div);
      let height = _div.offsetHeight;
      let width = _div.offsetWidth;
      // 需要显示logo
      if (that.barrageLogoIsShow === "Y") {
        const _img = document.createElement("img");
        _img.setAttribute("src", that.barrageLogoUrl);
        _img.style.display = "block";
        _img.style.width = height - 4 + "px";
        _img.style.height = height - 4 + "px";
        _img.style.marginRight = "5px";
        if (that.barrageDirection === "V") {
          _img.style.width = width - 4 + "px";
          _img.style.height = width - 4 + "px";
          _img.style.marginRight = 0;
          _img.style.marginBottom = "5px";
        }
        _div.insertBefore(_img, _span);
      }
      width = _div.offsetWidth;
      height = _div.offsetHeight;
      document.body.removeChild(_div);
      return {
        width,
        height,
      };
    },
    // 获取弹幕的位置
    barrageInitPositionGet() {
      const that = this;
      const { offsetWidth, offsetHeight } = that.$wrap;
      let left = offsetWidth;
      let top = offsetHeight * Math.random();
      if (top > offsetHeight - (parseFloat(14) + 80)) {
        top = offsetHeight - (parseFloat(14) + 80);
      }
      if (that.barrageDirection === "V") {
        top = offsetHeight;
        left = offsetWidth * Math.random();
        if (left > offsetWidth - (parseFloat(14) + 10)) {
          left = offsetWidth - (parseFloat(14) + 10);
        }
      }
      return {
        left,
        top,
      };
    },
    // 弹幕渲染
    barrageRender() {
      const that = this;
      const currentTime = that.player.currentTime();
      that.$wrap.querySelectorAll(".barrage").forEach((node) => {
        node.remove();
      });
      that.barrageRealList.forEach((item) => {
        if (!item.stopDrawing && item.showTime <= currentTime) {
          const _div = document.createElement("div");
          _div.style.opacity = that.barrageOpacity;
          _div.style.backgroundColor = that.barrageBackColor;
          if (that.barrageLogoIsShow === "Y") {
            const _img = document.createElement("img");
            _img.setAttribute("src", that.barrageLogoUrl);
            _img.setAttribute("class", "logo");
            _img.style.width = item.height - 4 + "px";
            _img.style.height = item.height - 4 + "px";
            if (that.barrageDirection === "V") {
              _img.style.width = item.width - 4 + "px";
              _img.style.height = item.width - 4 + "px";
            }
            _div.appendChild(_img);
          }
          const _span = document.createElement("span");
          if (that.barrageDirection === "V") {
            item.content = replaceAll(item.content, "!", "");
            item.content = replaceAll(item.content, "！", "");
            item.content = item.content.toUpperCase();
          }
          _span.innerText = item.content;
          _span.style.fontSize = 14 + "px";
          _span.style.color = that.barrageWordColor;
          if (that.barrageDirection === "V") {
            _div.setAttribute("class", "barrage v");
            item.top -= barrageX;
            _span.style.width = 14 + "px";
          } else {
            _div.setAttribute("class", "barrage");
            item.left -= barrageX;
            if (that.isFullScreen) {
              _div.style.width = item.width + 36 + "px";
            } else {
              _div.style.width = item.width + 6 + "px";
            }
          }
          _div.style.left = item.left + "px";
          _div.style.top = item.top + "px";
          _div.appendChild(_span);
          that.$wrap.appendChild(_div);
          if (that.barrageDirection === "V") {
            if (item.top <= item.height * -1) {
              item.stopDrawing = true;
            }
          } else {
            if (item.left <= item.width * -1) {
              item.stopDrawing = true;
            }
          }
        }
      });
      if (that.barragePause && that.setInterTime) {
        window.clearInterval(that.setInterTime);
        that.setInterTime = null;
      }
    },
    // 弹幕发送的时间节点获取
    handleBarrageTimeNode() {
      const that = this;
      if (that.isPicture === "Y") {
        return that.handleSecondToTimeStr(that.picCurrentTime);
      } else {
        return that.handleSecondToTimeStr(that.player.currentTime());
      }
    },
  },
  beforeDestroy() {
    if (this.setInterTime) {
      window.clearInterval(this.setInterTime);
      this.setInterTime = null;
    }
    if (this.picSetInterTime) {
      window.clearInterval(this.picSetInterTime);
      this.picSetInterTime = null;
    }
    if (this.picCurrentSetInterTime) {
      window.clearInterval(this.picCurrentSetInterTime);
      this.picCurrentSetInterTime = null;
    }
    if (this.player) {
      this.player.dispose();
    }
  },
};
</script>

<style lang="scss">
.barrage-wrap {
  touch-action: none;
  position: relative;
  z-index: 999;
  .barrage {
    position: absolute;
    top: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 200px;
    padding: 4px 5px;
    overflow: hidden;
    z-index: 999999;
    span {
      display: block;
    }
    .logo {
      margin-right: 5px;
      display: block;
      border-radius: 50%;
    }
    &.v {
      flex-direction: column;
      .logo {
        margin-right: 0;
        margin-bottom: 5px;
      }
      span {
        text-align: center;
        word-break: break-all;
        word-wrap: break-word;
        white-space: pre-wrap;
      }
    }
  }
}
</style>

<style scoped lang="scss">
.barrage-wrap {
  touch-action: none;
  overflow: hidden;
  position: relative;
  width: 100%;
  height: 100%;
  z-index: 999;
  .picture {
    width: 100%;
    height: 100%;
  }
  .video {
    width: 100%;
    height: 100%;
    display: block;
    z-index: 1000;
    video {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  .close {
    position: absolute;
    top: 25px;
    left: 25px;
    z-index: 999999;
    font-size: 40px;
    cursor: pointer;
  }
}
</style>
